import {
  CollegamentoRichiestaDTO,
  CollegamentoRichiestaDTODirezione,
  CollegamentoRichiestaDTOTipo,
} from '@framework/api-client';

export class SubmissionLinkLogic {
  /**
   * Ritorna la prima istanza collegata in uscita per il tipo specificato
   */
  static getFirstOutboundLink(
    links?: CollegamentoRichiestaDTO[] | null,
    type?: CollegamentoRichiestaDTOTipo,
  ) {
    return (
      links?.find(
        link =>
          link.direzione === CollegamentoRichiestaDTODirezione.USCITA &&
          (!type || link.tipo === type),
      ) ?? null
    );
  }
}
